import { useContext } from 'react';
import { appUserContext, ApplicationProvider, CustomerApplicationProvider } from 'helpers/services';
import { Route } from 'react-router-dom';
import { CustomerLayout, SimecLayout, NotAuthorizedLayout } from 'components';
import { UserTypology } from 'helpers/Enums';
import { IconContext } from 'react-icons';


let ErrorRoute = (props: any) => {
    let { hasLoaded, isAuthorized, currentUser } = useContext(appUserContext);

    return (
        <IconContext.Provider value={{ size: '20' }}>
            {hasLoaded === true &&
                <>
                    {isAuthorized === false &&
                        <NotAuthorizedLayout>
                            <Route {...props} />
                        </NotAuthorizedLayout>
                    }

                    {isAuthorized === true &&
                        <>
                            {currentUser.typology === UserTypology.Customer &&
                                <CustomerApplicationProvider>
                                    <CustomerLayout>
                                        <Route {...props} />
                                    </CustomerLayout>
                                </CustomerApplicationProvider>
                            }
                            {currentUser.typology === UserTypology.Simec &&
                                <ApplicationProvider>
                                    <SimecLayout>
                                        <Route {...props} />
                                    </SimecLayout>
                                </ApplicationProvider>
                            }
                        </>
                    }
                </>
            }
        </IconContext.Provider>
    )
}

export default ErrorRoute;